
import Markdown from "./Markdown";
import { markdownApi, useGetMarkdownQuery } from "./markdownApi";

export { markdownApi, useGetMarkdownQuery };
export default Markdown;
